<app-header [photo]='photo' [title]='title'></app-header>

<div class="wrapper">
    <p class="title is-1">THE SONG WAS SUCCESSFULLY ADDED TO YOUR LIBRARY</p>
</div>

<app-bottom></app-bottom>